import {createBridgeCaller} from '../BridgeApi';
import {Friend, SocialBridge, SocialResponseCallback} from '../socialBridge';
import PresenceType from '../../constants/PresenceType';
import {createClassLogger, Logger} from '../../utils/Logging';

interface FriendsResponse {
    friends: Friend[];
}

const BRIDGE_NAME = 'social';
const logger: Logger = createClassLogger('SocialBridge:Launcher');
const executeSocialBridgeCall = createBridgeCaller(BRIDGE_NAME, logger);

const socialBridge: SocialBridge = {
    /**
     * Returns an array of FriendStatusObjects
     */
    getFriendsList: async (): Promise<Friend[]> => {
        const response: FriendsResponse = await executeSocialBridgeCall<FriendsResponse>(
            'getfriendslist'
        );
        return (response && response.friends) || [];
    },

    /**
     * Returns user's online status
     */
    getOnlineStatus: (): Promise<PresenceType> => executeSocialBridgeCall('getonlinestatus'),

    setStatusOnline: (): Promise<void> => executeSocialBridgeCall('setonline'),

    setStatusAway: (): Promise<void> => executeSocialBridgeCall('setaway'),

    /**
     * Opens a chat window in the launcher
     */
    openChat: (friendId: string): Promise<void> => executeSocialBridgeCall('openchat', [friendId]),

    /**
     * Checks to see if the third party platform is installed on the users machine.
     * (e.g. thirdParty = 'steam')
     */
    hasThirdPartyAccounts: (thirdParty: string): Promise<boolean> =>
        executeSocialBridgeCall('hasthirdpartyaccounts', [thirdParty]),

    /**
     * Callback that can be registered to know about significant events as they happen
     */
    registerResponseCallback: (callback: SocialResponseCallback): Promise<void> =>
        executeSocialBridgeCall('registerresponsecallback', [callback])
};

export default socialBridge;
